// Adapted from https://github.com/okikio/bundle/blob/main/src/ts/util/WebWorker.ts, which is licensed under the MIT license.
// If the above file is removed or modified, you can access the original state in the following GitHub Gist: https://gist.github.com/okikio/6809cfc0cdbf1df4c0573addaaf7e259

export * from "./constants.ts";
export * from "./polyfill.ts";
export * from "./ponyfill.ts";

export { default } from "./polyfill.ts";